import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Numéro de la commande', 'numCommande', true),
  new ColumnExcel('Date de la commande', 'dateCommande', true),
  new ColumnExcel('Client', 'client'),
  new ColumnExcel('Produit', 'produit'),
  new ColumnExcel('Quantite', 'quantite'),
  new ColumnExcel('Prix unitaire', 'prixUnitaire'),
  new ColumnExcel('Taux remise', 'tauxRemise'),
  new ColumnExcel('Total Ht', 'totalHt'),
  new ColumnExcel('Taux Tva', 'tauxTva'),
];

export function templateConfig(data, nameFile, newColumns) {
  return new ExportExcel(`${nameFile || 'TemplateCommande'}.xlsx`, [
    new SheetExcel('Commandes', newColumns || columns, data,
      { skipHeader: false },
    ),
  ]);
}

export function generatedTemplateCommande() {
  const exemple = {};
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}

export function generatedErrorCommandeFile(data) {
  const newColumns = [
    new ColumnExcel('Commentaires', 'messages', true),
    ...columns,
  ];
  const dataFormat = data.map((el) => ({
    ...el, messages: el.messages.join(',\n'),
  }));
  const config = templateConfig(dataFormat, 'TemplateErrorCommande', newColumns);
  ExportToExcel(config);
}
